import { render } from "./Projects.vue?vue&type=template&id=e1a62b58&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e1a62b58"

export default script